import * as React from 'react'

import { Controller } from 'react-hook-form'

import StruxhubSearchableSelect, {
  SelectOption,
} from '../../StruxhubInputs/StruxhubSearchableSelect'
import { SelectFieldConfig } from '../types'
import { requiredSelectFieldValidator } from '../validators'

interface SelectFieldProps {
  field: SelectFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
  onOptionsChanged?: (options: SelectOption[]) => void
}

export default function SelectField({
  field,
  control,
  error,
  hideHelperText,
  onOptionsChanged,
}: SelectFieldProps) {
  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue || ''}
      rules={{
        validate: field.required ? requiredSelectFieldValidator : undefined,
      }}
      render={({ field: { onChange, value } }) => (
        <StruxhubSearchableSelect
          label={field.label}
          value={value}
          onChange={onChange}
          options={field.options}
          placeholder={field.placeholder}
          multiSelect={field.multiSelect}
          isRequired={field.required}
          isDisabled={field.disabled}
          isReadOnly={field.readOnly || field.displayOnly}
          isValid={!error}
          validationMessage={error}
          isHelperTextHidden={hideHelperText}
          allowUserCreation={field.allowUserCreation}
          onOptionsChanged={onOptionsChanged}
        />
      )}
    />
  )
}
